import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = { url: String, dueAt: String }

  connect() {
    if (this.overdue) {
      this.element.dataset.overdue = ""
    }
  }

  open(event) {
    if (event.target.closest("a, button, dialog")) return
    if (!window.getSelection().isCollapsed) return

    if (this.hasUrlValue) {
      visit(this.urlValue)
    }
  }

  get overdue() {
    return this.hasDueAtValue && new Date(this.dueAtValue) < new Date()
  }
}
